import React, { useState, useEffect } from "react";
import {
  Col,
  Container,
  Row,
  FormGroup,
  Button,
  Card,
  Label,
  Input,
} from "reactstrap";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import { useNavigate, useLocation } from "react-router-dom";
import { post, put, get } from "../../../api/axios";
import endpoints from "../../../api/endpoints";
import { toast, Bounce } from "react-toastify";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { values } from "lodash";
import { useSelector } from "react-redux";

const AddBank = () => {
  const [isUpdate, setIsUpdate] = useState(false);
  {
    isUpdate
      ? (document.title = "Edit Bank| Elevated - Admin Dashboard")
      : (document.title = "Add Bank | Elevated - Admin Dashboard");
  }
  const [bankId, setBankId] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [gymName, setGymName] = useState("");
  const location = useLocation();
  const { appRole, id } = useSelector((state) => state.auth.currentUser);
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(location.search);
  const gymId = searchParams.get("gymId");
  const [initialValues, setInitialValues] = useState({
    accountType: "checking",
    routingNumber: "",
    accountNumber: "",
    nameOnAccount: "",
    gymId: gymId,
    setPrimary: false,
  });
  const [selectedGym, setSelectedGym] = useState("");
  const [gymData, setGymData] = useState([]);
  const [seletedGymId, setSeletedGymId] = useState("");
  const gymIds = async () => {
    const resp = await get(`${endpoints.gym}/admin?userId=${id}&limit=50`);
    if (resp?.data?.success) {
      setGymData(resp.data.data);

      setSelectedGym(resp.data.data[0]?.name);
      setSeletedGymId(resp.data.data[0]?._id);
    }
  };

  useEffect(() => {
    if (appRole == "gymOwner" || appRole == "gymStaff") {
      gymIds();
    }
  }, []);
  const fetchBlogDetails = async (id) => {
    try {
      const response = await get(`${endpoints.bank}/${id}`);
      if (response?.data?.success) {
        const bankData = response.data.data;
        setBankId(bankData._id);
        setIsUpdate(true);
        setInitialValues({
          accountType: bankData?.accountType,
          routingNumber: bankData?.routingNumber?.$numberDecimal,
          accountNumber: bankData?.accountNumber?.$numberDecimal,
          nameOnAccount: bankData?.nameOnAccount,
          setPrimary: bankData?.setPrimary,
          gymId: bankData?.gymId ? bankData?.gymId : seletedGymId,
        });
      } else {
      }
    } catch (error) {
      console.error("Error fetching terms details:", error);
      toast.error("Failed to fetch terms details. Please try again.", {
        position: "bottom-center",
        theme: "colored",
        transition: Bounce,
      });
    }
  };

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);

    const bankIdFromParams = searchParams.get("bankId");
    setBankId(bankIdFromParams);

    if (bankIdFromParams) {
      setIsUpdate(true);
      fetchBlogDetails(bankIdFromParams);
    }
  }, [location.search]);
  const validationSchema = Yup.object().shape({
    accountType: Yup.string()
      .oneOf(
        ["checking", "savings", "businessChecking"],
        "Invalid account type"
      ) // Optional to enforce specific types
      .required("Account type is required"),
    routingNumber: Yup.string()
      .matches(
        /^\d{1,9}$/,
        "Routing number must be a numeric value  with up to 9 digits"
      )
      .required("Routing number is required"),
    accountNumber: Yup.string()
      .matches(
        /^\d{1,17}$/,
        "Account number must be a numeric value with up to 17 digits"
      )
      .required("Account number is required"),
    nameOnAccount: Yup.string()
      .max(22, "Name on account must be at most 22 characters")
      .required("Name on account is required"),
    setPrimary: Yup.boolean().required("SetPrimary is required"),
  });

  const handleSubmit = async (values) => {
    try {
      setIsSubmitting(true);
      if (isUpdate) {
        const resp = await put(`${endpoints.bank}/${bankId}`, values);

        if (resp.data.success) {
          navigate(`/list-bank?gymId=${gymId}`);
          toast.success("Bank Updated Successfully", {
            position: "bottom-center",
            theme: "colored",
            transition: Bounce,
          });
        } else {
          toast.error("Bank is  not stored", {
            position: "bottom-center",
            theme: "colored",
            transition: Bounce,
          });
        }
      } else {
        const resp = await post(`${endpoints.bank}`, values);
        if (resp.data.success) {
          navigate(`/list-bank?gymId=${gymId}`);
          toast.success("Bank Added Successfully", {
            position: "bottom-center",
            theme: "colored",
            transition: Bounce,
          });
        } else {
          toast.error("Bank is  not stored", {
            position: "bottom-center",
            theme: "colored",
            transition: Bounce,
          });
        }
      }
    } catch (error) {
      console.error(`Error ${isUpdate ? "updating" : "adding"} Term:`, error);
      toast.error("Something went wrong. Please try again.", {
        position: "bottom-center",
        theme: "colored",
        transition: Bounce,
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Container fluid>
      <Row>
        <Col>
          <Card className="rounded-4">
            <Formik
              initialValues={initialValues}
              validationSchema={validationSchema}
              onSubmit={handleSubmit}
              enableReinitialize
            >
              {({ errors, touched, resetForm, setFieldValue, values }) => (
                <Form className="p-4">
                  <h3 className="primary-black ff-sora font-size-20 fw-bold">
                    {isUpdate ? "Edit Bank" : "Add Bank"}
                  </h3>

                  {/* General Info */}

                  <Row className="d-flex align-items-center">
                    <Col lg={4}>
                      <FormGroup>
                        <Field
                          name="routingNumber"
                          type="text"
                          placeholder="Routing Number"
                          style={{
                            width: "100%",
                            maxWidth: "412px",
                            height: "56px",
                            border: "none",
                          }}
                          className={`rounded-5 bg-light ff-sora font-size-16 fw-normal px-4 ${
                            errors.routingNumber && touched.routingNumber
                              ? " is-invalid"
                              : ""
                          }`}
                        />
                        {errors.routingNumber && touched.routingNumber && (
                          <div className="text-danger font-size-12 ff-sora fw-normal my-1">
                            {errors.routingNumber}
                          </div>
                        )}
                      </FormGroup>
                    </Col>
                    <Col lg={4}>
                      <FormGroup>
                        <Field
                          name="accountNumber"
                          type="text"
                          placeholder="Accout Number"
                          style={{
                            width: "100%",
                            maxWidth: "412px",
                            height: "56px",
                            border: "none",
                          }}
                          className={`rounded-5 bg-light ff-sora font-size-16 fw-normal px-4 ${
                            errors.accountNumber && touched.accountNumber
                              ? " is-invalid"
                              : ""
                          }`}
                        />
                        {errors.accountNumber && touched.accountNumber && (
                          <div className="text-danger font-size-12 ff-sora fw-normal my-1">
                            {errors.accountNumber}
                          </div>
                        )}
                      </FormGroup>
                    </Col>
                    <Col lg={4}>
                      <FormGroup>
                        <Field
                          name="nameOnAccount"
                          type="text"
                          placeholder="Name on account"
                          style={{
                            width: "100%",
                            maxWidth: "412px",
                            height: "56px",
                            border: "none",
                          }}
                          className={`rounded-5 bg-light ff-sora font-size-16 fw-normal px-4 ${
                            errors.nameOnAccount && touched.nameOnAccount
                              ? " is-invalid"
                              : ""
                          }`}
                        />
                        {errors.nameOnAccount && touched.nameOnAccount && (
                          <div className="text-danger font-size-12 ff-sora fw-normal my-1">
                            {errors.nameOnAccount}
                          </div>
                        )}
                      </FormGroup>
                    </Col>
                    <Col lg={4}>
                      <FormGroup>
                        <Input
                          name="accountType"
                          style={{
                            width: "100%",
                            maxWidth: "420px",
                            height: "56px",
                            border: "none",
                          }}
                          value={values?.accountType}
                          className={`rounded-5 bg-light ff-sora font-size-16 px-4 fw-normal form-control `}
                          type="select"
                          onChange={(e) => {
                            const selectedValue = e.target.value;
                            setFieldValue("accountType", selectedValue);
                          }}
                        >
                          <option key={0} value={"checking"}>
                            Checking
                          </option>
                          <option key={1} value={"savings"}>
                            Savings
                          </option>
                          <option key={2} value={"businessChecking"}>
                            Business Checking
                          </option>
                        </Input>
                      </FormGroup>
                    </Col>

                    <Col lg={4}>
                      {(appRole == "gymOwner" || appRole == "gymStaff") && (
                        <FormGroup>
                          <Input
                            name="gymId"
                            style={{
                              width: "100%",
                              maxWidth: "420px",
                              height: "56px",
                              border: "none",
                            }}
                            className={`rounded-5 bg-light ff-sora font-size-16 px-4 fw-normal form-control `}
                            type="select"
                            onChange={(e) => {
                              const selectedValue = e.target.value;
                              setSeletedGymId(selectedValue);

                              const selectedGym = gymData.find(
                                (gym) => gym._id === selectedValue
                              );

                              if (selectedGym) {
                                setGymName(selectedGym.name);
                              }
                            }}
                          >
                            {gymData.map((item, index) => {
                              return (
                                <option
                                  key={index}
                                  value={item._id}
                                  selected={gymId == item._id ? true : false}
                                >
                                  {item.name}

                                  <small style={{ fontSize: "9px" }}>
                                    (Selected GYM)
                                  </small>
                                </option>
                              );
                            })}
                          </Input>
                        </FormGroup>
                      )}
                    </Col>
                    <Col lg={4}>
                      <FormGroup className="d-flex align-items-center">
                        <Input
                          name="setPrimary"
                          type="checkbox"
                          checked={values.setPrimary}
                          className="secondary-black m-0"
                          style={{
                            borderColor: "#525252",
                            width: "20px",
                            height: "20px",
                          }}
                          onChange={(e) => {
                            const selectedValue = e.target.checked;
                            setFieldValue("setPrimary", selectedValue);
                          }}
                        />
                        {console.log(values?.setPrimary, "values.setPrimary")}
                        <Label
                          check={values.setPrimary}
                          className="ff-sora font-size-16 my-1 px-2"
                        >
                          Set Primary
                        </Label>
                      </FormGroup>
                    </Col>
                  </Row>

                  {/* Submit Button */}
                  <div className="d-flex justify-content-end mt-4">
                    <Button
                      type="submit"
                      className="me-2 rounded-pill"
                      disabled={isSubmitting}
                    >
                      {isSubmitting ? (
                        isUpdate ? (
                          <span>Updating...</span>
                        ) : (
                          <span>Adding...</span>
                        )
                      ) : isUpdate ? (
                        "Update Bank"
                      ) : (
                        "Add Bank"
                      )}
                    </Button>
                    <Button
                      color="white"
                      className="rounded-pill1"
                      onClick={() => {
                        resetForm();
                        if (isUpdate) {
                          navigate(`/list-bank?gymId=${gymId}`);
                        }
                      }}
                    >
                      Cancel
                    </Button>
                  </div>
                </Form>
              )}
            </Formik>
          </Card>
          <div
            className="d-flex justify-content-between align-items-center"
            style={{
              height: "60px",
              position: "sticky",
              bottom: "0",
              zIndex: "10",
            }}
          ></div>
        </Col>
      </Row>
    </Container>
  );
};

export default AddBank;
